import React, { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";
import { PolarisStar } from "@/components/site/PolarisStar";

const LINKS = [
  { label: "Áreas", href: "#areas" },
  { label: "Servicios", href: "#servicios" },
  { label: "Familia", href: "#family" },
  { label: "Experiencia", href: "#experiencia" },
  { label: "Contacto", href: "#contacto" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#fbf7f1]/85 backdrop-blur-xl border-b border-[#e4dccf]" : "bg-transparent"
      }`}
    >
      <div
        data-testid="top-announcement"
        className="bg-[#2b2a33] text-white text-xs md:text-sm py-2 px-4 flex items-center justify-center gap-2"
      >
        <PolarisStar className="w-4 h-4 shrink-0" />
        <span className="font-medium tracking-wide text-center">
          Guiamos a personas y empresas en la dirección correcta.
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <PolarisStar className="w-7 h-7 group-hover:rotate-45 transition-transform duration-500" />
          <span className="font-display text-xl font-extrabold tracking-tight">
            {BRAND.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#6b6873] hover:text-[#2b2a33] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#agendar"
          data-testid="nav-cta-agendar"
          className="hidden md:inline-flex items-center gap-2 bg-[#2b2a33] text-white text-sm font-semibold px-5 py-3 rounded-full hover:bg-[#ff5c49] transition-colors"
        >
          Agendar llamada <ArrowUpRight className="w-4 h-4" />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#2b2a33]"
          aria-label="Menú"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#fbf7f1] border-t border-[#e4dccf] px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="text-base font-medium text-[#2b2a33]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#agendar"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-cta"
            className="inline-flex items-center justify-center gap-2 bg-[#ff5c49] text-white font-semibold px-5 py-3 rounded-full"
          >
            Agendar llamada
          </a>
        </div>
      )}
    </header>
  );
};
